import CardTitleWithIcon from "@/components/company/card-title-with-icon";
import StatTile from "@/components/company/shared/stat-tile";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useTranslation } from "@/hooks/useTranslation";
import { formatDateLong } from "@/lib/format-amount";
import { CompanyDTO } from "@shaarp/common";
import { BuildingIcon, CalendarIcon, LineChartIcon, TagIcon } from "lucide-react";

type CardCompanyStockProps = {
  readonly company: CompanyDTO;
};

export default function CardCompanyStock({ company }: CardCompanyStockProps) {
  const { t, i18n } = useTranslation();
  const stock = company.stock;

  if (!stock?.isPubliclyTraded) return null;
  if (!stock.ticker && !stock.exchange && !stock.ipoDate) return null;

  return (
    <Card className="overflow-hidden">
      <CardHeader className="pb-3 sm:pb-4">
        <CardTitleWithIcon
          icon={LineChartIcon}
          title={t("company.insights.stock.title")}
        />
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 @sm:grid-cols-3 gap-4">
          {stock.ticker && (
            <StatTile
              icon={TagIcon}
              tone="emerald"
              label={t("company.insights.stock.ticker")}
              value={stock.ticker}
              valueClassName="font-mono"
            />
          )}
          {stock.exchange && (
            <StatTile
              icon={BuildingIcon}
              tone="sky"
              label={t("company.insights.stock.exchange")}
              value={stock.exchange}
            />
          )}
          {stock.ipoDate && (
            <StatTile
              icon={CalendarIcon}
              tone="amber"
              label={t("company.insights.stock.ipoDate")}
              value={formatDateLong(stock.ipoDate, i18n.language)}
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
}
